module.exports = __webpack_public_path__ + "67661045b4c5b18418317a2276c76046.svg";